<ul
  *ngIf="(state | async)[component].count > (state | async).params.limit"
  class="uk-pagination uk-flex-center"
  [ngClass]="{ 'column-center-small': navOpen }">
  <li [ngClass]="{ 'not-allowed': !(state | async)[component].previous }">
    <a class="uk-flex uk-flex-middle" (click)="getPreviousResults()" [ngClass]="{ 'uk-disabled': !(state | async)[component].previous }">
      <span class="margin-small-right" uk-pagination-previous></span>

      <span i18n="@@Previous">Previous</span>
    </a>
  </li>

  <li *ngFor="let number of (state | async).pagesNumber | numberIterator | paginationPages: (state | async).activePageNumber">
    <ng-container *ngIf="number === (state | async).activePageNumber; else template">
      <span [ngClass]="{ 'uk-active not-allowed active-page-number': number === (state | async).activePageNumber }">{{ number }}</span>
    </ng-container>

    <ng-template #template>
      <ng-container *ngIf="number !== 0; else ellipsis">
        <a [ngClass]="{ 'hide-small-screen': navOpen }" (click)="getResultsFromPage(number)">{{ number }}</a>
      </ng-container>

      <ng-template #ellipsis>
        <span [ngClass]="{ 'hide-small-screen': navOpen }">...</span>
      </ng-template>
    </ng-template>
  </li>

  <li [ngClass]="{ 'not-allowed': !(state | async)[component].next }">
    <a class="uk-flex uk-flex-middle" (click)="getNextResults()" [ngClass]="{ 'uk-disabled': !(state | async)[component].next }">
      <span class="margin-small-right" i18n="@@Next">Next</span>

      <span uk-pagination-next></span>
    </a>
  </li>
</ul>
